var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-43",
    "data-name": "50_Kids_Icons-43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#78bede"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4860",
    "data-name": "Group 4860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    "data-name": "Group 4842",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M152.947,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.922,244.065,152.947,246.493Z",
    transform: "translate(-123.38 -204.934)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M320,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S321.025,244.065,320,246.492Z",
    transform: "translate(-269.567 -204.934)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4843",
    "data-name": "Group 4843",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M128.4,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-59.397 -326.964)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4844",
    "data-name": "Group 4844",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M226.979,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-180.384 -214.962)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4846",
    "data-name": "Group 4846",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4845",
    "data-name": "Group 4845",
    transform: "translate(26.617 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M197.113,143.36a10.422,10.422,0,0,1-10.423,10.422h-5.923a10.422,10.422,0,0,1-10.422-10.422V126.306a10.422,10.422,0,0,1,10.422-10.422h5.923a10.422,10.422,0,0,1,10.423,10.422Z",
    transform: "translate(-170.346 -115.884)",
    fill: "#ffdbc5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4847",
    "data-name": "Group 4847",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(33.321 40.012)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(43.584 40.012)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4848",
    "data-name": "Group 4848",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M244.43,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.43,279.542Z",
    transform: "translate(-202.216 -235.864)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4849",
    "data-name": "Group 4849",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M128.39,425.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-59.398 -339.904)",
    fill: "#966796"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4850",
    "data-name": "Group 4850",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_285",
    "data-name": "Ellipse 285",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(45.469 43.107)",
    fill: "#f5b8a7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_286",
    "data-name": "Ellipse 286",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(28.281 43.107)",
    fill: "#f5b8a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4851",
    "data-name": "Group 4851",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M229.511,310.367a4.883,4.883,0,0,1-6.487,0c-1.231-1.159-3.091.694-1.856,1.856a7.56,7.56,0,0,0,10.2,0c1.235-1.163-.625-3.015-1.856-1.856Z",
    transform: "translate(-186.267 -261.563)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4854",
    "data-name": "Group 4854",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4852",
    "data-name": "Group 4852",
    transform: "translate(30.278 35.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M195.38,228.983a9.168,9.168,0,0,1,4.327-.877,1.053,1.053,0,0,0,0-2.105,11.422,11.422,0,0,0-5.39,1.165c-1.215.607-.148,2.423,1.063,1.818Z",
    transform: "translate(-193.781 -225.997)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4853",
    "data-name": "Group 4853",
    transform: "translate(42.778 35.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M279.126,228.983a9.168,9.168,0,0,0-4.327-.877,1.053,1.053,0,0,1,0-2.105,11.423,11.423,0,0,1,5.39,1.165c1.215.607.148,2.423-1.062,1.818Z",
    transform: "translate(-273.781 -225.997)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4859",
    "data-name": "Group 4859",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4855",
    "data-name": "Group 4855",
    transform: "translate(24.818 15.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M161.224,123.42l.609-5.347a5.61,5.61,0,0,1,5.574-4.975h13.215a5.61,5.61,0,0,1,5.574,4.974l.61,5.348h1.534a18.869,18.869,0,0,0,.857-5.65c0-9.405-6.8-17.029-15.182-17.029s-15.182,7.624-15.182,17.029a18.864,18.864,0,0,0,.857,5.65Z",
    transform: "translate(-158.833 -100.742)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4858",
    "data-name": "Group 4858",
    transform: "translate(24.754 23.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4856",
    "data-name": "Group 4856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M158.427,166.012l2.367-.073L162.3,147.43l-3.074,6.008Z",
    transform: "translate(-158.427 -147.43)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4857",
    "data-name": "Group 4857",
    transform: "translate(26.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M332.632,166.012l-2.367-.073-1.511-18.508,3.074,6.008Z",
    transform: "translate(-328.754 -147.43)",
    fill: "#3d2a3d"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar12);
export default __webpack_public_path__ + "static/media/avatar12.2884e49ad358623bfd5446e80d00b5d4.svg";
export { ForwardRef as ReactComponent };